// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from '../utils/requst';
import axios from 'axios'
import {baseUrl} from '../utils/url';

export default {
    async uploadLogo(formData:any) {
        console.log('uploadLogo:', formData);
        return axios({
            headers: {'Content-Type': 'multipart/form-data'},
            baseURL: `${baseUrl}`,
            url: `commonUploadImg`,
            method: 'POST',
            data: formData
        });
    },

    // eslint-disable-next-line @typescript-eslint/ban-types
    async register(params:any) {
        console.log(params);
        return request.post('register', params);
    },

    async login(params:any){
        return request.post('app/login', params);
    },

    async getUsersInfo(){
        return request.get('app/userInfo', {
            params: {

            }
        });
    }
}
